var parseFormDataDefaultsToProductQuery = function (formDataResponseObject) {
    return {
        TRAVELLERS_ADULTS: formDataResponseObject.travellers.adults.default,
        TRAVEL_PERIOD_DEPARTURE_DATE: formDataResponseObject.travelPeriod.departureDate.default,
        TRAVEL_PERIOD_RETURN_DATE: formDataResponseObject.travelPeriod.returnDate.default,
        TRAVEL_PERIOD_DURATION: formDataResponseObject.travelPeriod.duration.default,
    };
};
var FormDataToQueryMapper = /** @class */ (function () {
    function FormDataToQueryMapper() {
    }
    FormDataToQueryMapper.map = function (formDataResponseObject) {
        if (formDataResponseObject === null) {
            return null;
        }
        return parseFormDataDefaultsToProductQuery(formDataResponseObject);
    };
    return FormDataToQueryMapper;
}());
export default FormDataToQueryMapper;
